import React, { useEffect, useState } from 'react';
import { useDropDown } from '../../../hooks/useDropDown';
import clsx from 'clsx';

interface OptionProp {
  label: string;
  value: string;
  disabled?: boolean;
}

interface DropdownProps {
  id: string;
  name: string;
  label: string;
  options: HTMLOptionElement[];
}

export const Dropdown: React.FC<DropdownProps> = ({
  label,
  options,
  id,
  name,
}) => {
  const [formattedOptions, setFormattedOptions] = useState<null | OptionProp[]>(
    null,
  );
  const [placeHolder, setPlaceholder] = useState<null | OptionProp>(null);

  const [isActive, setIsActive] = useState<boolean>(false);

  const { containerRef, linkRef } = useDropDown({ expanded: isActive });

  const [selectedValue, setSelectedValue] = useState<null | OptionProp>(null);

  useEffect(() => {
    const newOptions = [];
    for (const option of options) {
      const newOption = {
        label: option.innerHTML,
        value: option.value,
        disabled: option.disabled,
      };
      if (newOption.disabled) {
        setPlaceholder(newOption);
      } else {
        newOptions.push(newOption);
      }
    }
    setFormattedOptions(newOptions);
  }, []);

  const activeHandler = () => {
    setIsActive(!isActive);
  };

  const selectHandler = (value: OptionProp) => {
    setSelectedValue(value);
  };

  return (
    <>
      <div
        className={clsx('whl-relative whl-min-h-[64px]', {
          'whl-z-[2000]': isActive === true,
        })}
      >
        <p className="whl-text-neutral-800 whl-text-xs">{label}</p>
        <div
          className={clsx(
            'whl-absolute whl-h-auto whl-min-h-[33px] whl-w-full whl-cursor-pointer whl-overflow-hidden whl-rounded-md whl-border-[1px] whl-border-light-grey whl-bg-white whl-px-[4px] whl-pb-[4px] whl-transition-all',
            `
            ${label && label.length > 45 ? 'whl-top-[40px]' : 'whl-top-[25px]'}
            `,
            'lg:whl-top-[25px]',
          )}
          ref={containerRef}
          onClick={activeHandler}
        >
          <ul
            ref={linkRef}
            className={clsx('whl-mt-[2px] whl-py-[5px]', {
              'whl-pointer-events-none': isActive === false,
            })}
          >
            <input
              id={id}
              name={name}
              className="whl-text-neutral-800 placeholder:whl-text-neutral-300 whl-pointer-events-none !whl-translate-y-[-4px] !whl-border-none !whl-bg-white !whl-px-[10.78px] whl-text-xs !whl-shadow-none placeholder:whl-text-xs"
              placeholder={placeHolder?.label}
              value={selectedValue?.value || ''}
              readOnly={true}
            />
            {formattedOptions?.map(option => {
              return (
                <li
                  key={option.label}
                  value={option.value}
                  onClick={() => selectHandler(option)}
                  className="whl-cursor-pointer whl-px-[10.78px] whl-py-[6.7px] whl-text-xs whl-text-grey hover:whl-rounded-sm hover:whl-border-[1px] hover:whl-border-light-grey hover:whl-bg-light-grey hover:whl-py-[5.7px] hover:whl-font-bold"
                >
                  {option.label}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};
